import { blue20opacity15 } from '../../../colors/blue';
import { gray40opacity10 } from '../../../colors/gray';
export var MuiMenuItem = {
    styleOverrides: {
        root: {
            '&:hover': {
                backgroundColor: gray40opacity10,
            },
            '&:active': {
                backgroundColor: blue20opacity15,
            },
        },
    },
};
